export default __webpack_public_path__ + "static/media/ligo-bots.da4efe2e.svg";